const VideoTypesTutorials = () => (
  <section className="bg-common-white text-[#151012] pt-24 pb-12 md:pb-24 px-4 text-center">
    <h3 className="font-primary text-title md:text-heroTitle !font-extraBold">We can talk you through it</h3>
    <strong className="block font-primary text-body font-bold md:text-heroSubtitle text-[#6F6F6F] mt-4 mb-6 md:mb-24">
      SATPrac offers 4 main types of video tutorials
    </strong>

    <div className="flex justify-between flex-wrap w-full max-w-2xl mx-auto gap-5 md:gap-10">
      {
        TYPES.map((type, index) =>
          <TypeItem key={index} index={index} {...type} />)
      }
    </div>
  </section>
);

const TypeItem = ({ index, title, description }: { index: number; title: string; description: string }) => (
  <div className="flex flex-col items-start gap-1 w-[19rem] text-left mx-auto">
    <strong className="font-primary font-bold text-heroSubtitle text-[#151012]">
      <span className="text-primary">0{index + 1} </span>{title}
    </strong>
    <p className="leading-normal text-callout text-[#6F6F6F]" dangerouslySetInnerHTML={{ __html: description }} />
  </div>
);

const TYPES = [
  {
    title: 'Question Types',
    description: 'Show you the key fundamental facts and strategies needed for each of the 43 question types'
  },
  {
    title: 'Question Bank',
    description: 'Show you how to do all the questions from the Question Bank'
  },
  {
    title: 'Text Explanations',
    description: `
      Teach you the key fundamentals, shortcuts, and strategies needed to dominate each and every question from
      the Bluebook and <span class="text-primary font-bold">SATPrac</span> tests
    `
  },
  {
    title: 'Strategy',
    description: 'Discuss various study strategies and work through the 3 step approach needed for victory on game day'
  },
];

export default VideoTypesTutorials;
